import { Modal } from '@tes/ui';
import { VariableLibraryPanel } from './VariableLibraryPanel';

/** Popup used from the template editor ("quickly edit the library"). */
export function VariableLibraryModal({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="Variable library" onClose={onClose} size="xl">
      <VariableLibraryPanel />
    </Modal>
  );
}
